import { useState } from 'react';
import styled from 'styled-components';
import { color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export default function TitleSearch() {
  const [searchValue, setSearchValue] = useState(urlParams.get('query') || '');
  const [searchFormOpen, setSearchFormOpen] = useState(false);

  return (
    <Form
      action="/explore/search"
      method="get"
      acceptCharset="UTF-8"
      searchFormOpen={searchFormOpen}
    >
      <SearchIconWrapper
        data-tip="Search"
        data-for="SearchButton"
        onClick={() => setSearchFormOpen(state => !state)}
        className="fa-solid fa-search fa-xl"
      />
      <input name="utf8" type="hidden" value="✓" />
      <SearchInput
        color="black.80"
        type="text"
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        name="query"
        placeholder="Search Tile"
      />
      {searchValue && (
        <CloseIcon
          width="15"
          height="15"
          onClick={() => {
            setSearchValue('');
          }}
        />
      )}
    </Form>
  );
}

const Form = styled.form`
  display: none;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 10px;
    width: ${props => (props.searchFormOpen ? '380px' : '32px')};
    border-bottom: ${props => (props.searchFormOpen ? '1px solid' : 'none')};
    transition: all 1s ease;
    padding: 6px;
    border-color: ${themeGet('colors.black.10')};
  }
`;

const SearchIconWrapper = styled.i`
  cursor: pointer;
  &:hover {
    color: ${themeGet('colors.black.60')};
  }
`;

const SearchInput = styled.input`
  ${color};
  border: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  border: 0;
  width: calc(100% - 28px);
  background: transparent !important;
`;

const CloseIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-light fa-xmark',
  }),
)`
  margin: 0 10px;
  cursor: pointer;
`;
